import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, withScopeId as _withScopeId } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_NormalPoolActionsCard = _resolveComponent("NormalPoolActionsCard")!
  const _component_FarmActionsCard = _resolveComponent("FarmActionsCard")!
  const _component_BalModal = _resolveComponent("BalModal")!

  return (_openBlock(), _createBlock(_component_BalModal, {
    show: "",
    onClose: _ctx.onClose,
    title: _ctx.$t('Farm')
  }, {
    default: _withCtx(() => [
      (!_ctx.hasFarm)
        ? (_openBlock(), _createBlock(_component_NormalPoolActionsCard, {
            key: 0,
            "token-address": _ctx.tokenAddress
          }, null, 8, ["token-address"]))
        : _createCommentVNode("", true),
      (_ctx.hasFarm)
        ? (_openBlock(), _createBlock(_component_FarmActionsCard, {
            key: 1,
            "has-unstaked-bpt": _ctx.hasUnstakedBpt,
            "token-address": _ctx.tokenAddress,
            "farm-id": _ctx.farmId,
            "has-farm-rewards": _ctx.hasFarmRewards
          }, null, 8, ["has-unstaked-bpt", "token-address", "farm-id", "has-farm-rewards"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["onClose", "title"]))
}